import React from 'react';
import { I18nContextType, useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Dropdown } from '@hz-design-system/web-ui';

import { linkGeneratorHelper, generateLinkObject } from '@/utils/links/linkGeneratorHelper';
import getClientPageQueryObject from '@/client/utils/getClientPageQueryObject';
import pushToRouter from '@/client/utils/pushToRouter';

type TSorterControlProps = {
  searchRequestObject: TSearchRequestObject;
  sortOptions: TSortOption[];
  withAllAttributes: boolean;
};

const getTranslation = (
  { sortBy, sortOrder, sortAttribute }: { sortBy: string; sortOrder: string; sortAttribute?: string },
  t: I18nContextType['t'],
) => {
  const key = `${sortBy}.${sortOrder}${sortAttribute ? `.${sortAttribute}` : ''}`.toLowerCase();
  return t(`viewControls.sorting.${key}`);
};

const getTranslatedOptions = (options: TSortOption[], t: I18nContextType['t']) =>
  options.map((option) => ({
    label: getTranslation(option, t),
    value: JSON.stringify(option),
  }));

const onSortChange = (searchRequestObject: TSearchRequestObject, sortOptions: string, withAllAttributes: boolean) => {
  const linkOptions = {
    searchRequestObject,
    sortOptions: JSON.parse(sortOptions),
    withAllAttributes,
  };
  const href = linkGeneratorHelper(linkOptions);
  const query = getClientPageQueryObject(generateLinkObject(linkOptions));
  pushToRouter({ query, href });
};

const SorterControl = ({ searchRequestObject, sortOptions, withAllAttributes }: TSorterControlProps) => {
  const { t } = useI18nContext();
  const { sortOptions: selected } = searchRequestObject;
  const selectedOption = sortOptions.find((sortOption) => {
    if (sortOption.sortAttribute) {
      return sortOption.sortOrder === selected.sortOrder && sortOption.sortAttribute === selected.sortAttribute;
    }
    return sortOption.sortOrder === selected.sortOrder && sortOption.sortBy === selected.sortBy;
  });

  return (
    <>
      <Dropdown
        className="hz-ViewControl--sort-options"
        labelText={t('viewControls.sorting.sortBy')}
        value={selectedOption && JSON.stringify(selectedOption)}
        options={getTranslatedOptions(sortOptions, t)}
        onChange={(event) => onSortChange(searchRequestObject, event.target.value, withAllAttributes)}
      />
    </>
  );
};

export default SorterControl;
